import { render, staticRenderFns } from "./SavedSearchWizard.vue?vue&type=template&id=38af6f23&"
import script from "./SavedSearchWizard.vue?vue&type=script&lang=js&"
export * from "./SavedSearchWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports